import React from "react";

// Iron House Design System — Badge (copiado do DS oficial, + import React).
export function Badge(props) {
  const { children, variant = "default", size = "md", className = "", ...rest } = props;

  const sizeMap = {
    sm: { fontSize: "9px", padding: "3px 8px" },
    md: { fontSize: "11px", padding: "4px 10px" },
    lg: { fontSize: "12px", padding: "5px 14px" },
  };

  const variantMap = {
    default: { background: "var(--neutral-200)", color: "var(--neutral-700)" },
    green: { background: "var(--color-green)", color: "var(--color-black)" },
    dark: { background: "var(--color-black)", color: "var(--color-white)" },
    iron: { background: "var(--color-iron)", color: "var(--color-white)" },
    outline: { background: "transparent", color: "var(--color-green)", border: "1px solid var(--color-green)" },
    success: { background: "rgba(34,197,94,0.15)", color: "#16A34A" },
    warning: { background: "rgba(234,179,8,0.15)", color: "#B45309" },
    error: { background: "rgba(239,68,68,0.15)", color: "#DC2626" },
  };

  const style = {
    fontFamily: "var(--font-body)",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "var(--tracking-wide)",
    borderRadius: "var(--radius-full)",
    display: "inline-flex",
    alignItems: "center",
    gap: "var(--space-1)",
    lineHeight: 1,
    whiteSpace: "nowrap",
    border: "none",
    ...sizeMap[size],
    ...variantMap[variant],
  };

  return (
    <span style={style} className={className} {...rest}>
      {children}
    </span>
  );
}

export default Badge;
